import { render } from "./TerminIndex.vue?vue&type=template&id=8019783a&scoped=true"
import script from "./TerminIndex.vue?vue&type=script&lang=js"
export * from "./TerminIndex.vue?vue&type=script&lang=js"

import "./TerminIndex.vue?vue&type=style&index=0&id=8019783a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8019783a"]])

export default __exports__